<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="机构名称" v-model="insName"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="devId"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input
          placeholder="个人超级管理员手机号码"
          v-model="mobile"
        ></el-input>
      </el-col>
      <el-col :span="3">
        <el-input placeholder="车牌号" v-model="carNumber"></el-input>
      </el-col>
      <el-col :span="3">
        <el-select v-model="status" placeholder="状态">
          <el-option
            v-for="(message, code) in statusCode"
            :key="code"
            :label="message"
            :value="parseInt(code)"
          />
        </el-select>
      </el-col>
      <el-col :span="2" style="margin-left: 50px">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2">
        <el-button type="success" @click="add">添加设备</el-button>
      </el-col>
    </el-row>
    <el-button type="primary" @click="onDelete('list', radio)"
      >批量删除</el-button
    >
    <el-checkbox
      style="margin-left: 20px"
      @change="handleAyncChange('all', $event)"
      v-model="allAync2"
    ></el-checkbox>
    <span style="margin-left: 5px" type="primary"
      >同步所有机构下的所有设备</span
    >
    <el-table
      default-expand-all
      row-key="activeId"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column label="机构名称/个人管理手机号">
        <template slot-scope="scope">
          <el-checkbox
            @change="handleCheckChange(scope.row.activeId, $event)"
            v-model="radio[scope.row.activeId]"
          ></el-checkbox>
          {{ scope.row.ownerName || scope.row.activeId }}

          <!-- <span style="margin-left: 100px;">
              {{
                scope.row.activeId && !scope.row.ownerName
                  ? "绑定时间: " + scope.row.bindingTime || ""
                  : ""
              }}
            </span> -->

          <!-- <div v-show="!!scope.row.ownerName">{{scope.row.ownerName}}</div>
           <div v-show="scope.row.activeId && !scope.row.ownerName">{{scope.row.activeId}}</div> -->
        </template>
      </el-table-column>
      <el-table-column
        :label="
          apiHost.path == 'gdMerchant' ? '冷链设备编号' : '运荔枝设备编号'
        "
      >
        <template slot-scope="scope">
          {{ scope.row.gdDevId }}
        </template>
      </el-table-column>

      <el-table-column label="绑定时间" width="150">
        <template slot-scope="scope">
          {{ scope.row.bindingTime }}
        </template>
      </el-table-column>
      <el-table-column label="真实车牌" width="150">
        <template slot-scope="scope">
          {{ scope.row.carNumber }}
        </template>
      </el-table-column>
      <el-table-column label="个人/机构">
        <template slot-scope="scope">
          {{
            scope.row.userType == 0
              ? "机构"
              : scope.row.activeId && !scope.row.ownerName
              ? ""
              : "个人"
          }}
          <el-checkbox
            style="margin-left: 5px"
            v-show="!!scope.row.ownerName"
            @change="handleAyncChange('single', scope.row)"
            v-model="scope.row.syncFlag"
          ></el-checkbox>
          <span style="margin-left: 2px" v-show="!!scope.row.ownerName"
            >同步本{{
              scope.row.userType == 0
                ? "机构"
                : scope.row.activeId && !scope.row.ownerName
                ? ""
                : "个人"
            }}下所有设备</span
          >
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          {{ statusCode[scope.row.status] }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <div style="display: flex">
            <el-button
              type="text"
              size="small"
              @click="onRegister('sel', scope.row.activeId + '')"
              >{{
                scope.row.activeId && !scope.row.ownerName ? "注册鉴权" : ""
              }}
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="onDelete('sel', scope.row.activeId + '')"
              >{{
                scope.row.activeId && !scope.row.ownerName ? "删除" : "全部删除"
              }}
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="onLogout('sel', scope.row.activeId + '')"
              >{{
                scope.row.activeId && !scope.row.ownerName ? "注销" : "全部注销"
              }}
            </el-button>
            <el-button
              type="text"
              size="small"
              v-if="apiHost.path !== 'gdMerchant'"
              @click="onData(scope.row)"
            >
              {{ statusCode[scope.row.status] && "数据补传" }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
    <el-dialog
      :visible.sync="dataDialogVisible"
      :data="rowData"
      title="数据补传"
      width="30%"
      center
      @closed="closed"
    >
      <el-form
        label-width="80px"
        :model="formUpdate"
        :rules="rules"
        ref="formUpdate"
      >
        <el-form-item label="设备编号" prop="devId">
          <el-input v-model="formUpdate.devId" disabled></el-input>
        </el-form-item>
        <el-form-item label="起始日期" required prop="startTime">
          <el-date-picker
            v-model="formUpdate.startTime"
            type="datetime"
            placeholder="选择起始日期时间"
            style="width: 100%"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" required prop="endTime">
          <el-date-picker
            v-model="formUpdate.endTime"
            type="datetime"
            placeholder="选择结束日期时间"
            style="width: 100%"
            value-format="timestamp"
            default-time="23:59:59"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="ConfirmLoading"
          @click="submitForm('formUpdate')"
          >上传</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>


<script>
import Pagination from "@/components/Pagination";

import { STATUS_CODE } from "@/constant";
export default {
  name: "GdDevice",
  props: {
    apiHost: {
      path: "gdMerchant",
      urlQuery: "?isGdLl=true",
    },
  },
  data() {
    return {
      pagin: {
        pageNum: 1,
        size: 10,
        total: 0,
        isDefaultPageSizes: true,
      },
      carNumber: "",
      statusCode: STATUS_CODE,
      mchId: +this.$route.params.id,
      allAync: false,
      allAync2: false,
      disAds: [],
      insName: "",
      status: "",
      devId: "",
      mobile: "",
      radio: {},
      preRadio: {},
      tableData: [],
      multipleSelection: [],
      ConfirmLoading: false,
      dataDialogVisible: false,
      rowData: {},
      formUpdate: {
        devId: "",
        startTime: "",
        endTime: "",
      },
      rules: {
        startTime: [{ required: true, message: "请选择", trigger: "blur" }],
        endTime: [{ required: true, message: "请选择", trigger: "blur" }],
      },
    };
  },

  methods: {
    add() {
      console.log(this.apiHost);
      this.$router.push(
        "/api/index/addDevice/" + this.mchId + this.apiHost.urlQuery
      );
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    handleAyncChange(type, val) {
      if (type === "single") {
        let params = {
          userType: val.userType,
          mchId: val.mchId,
          type: val.syncFlag ? 1 : 0,
          insId: val.insId || undefined,
          userId: val.userId || undefined,
        };
        this.$http
          .post(`/senddataserver/${this.apiHost.path}/sync/single`, params)
          .then((rs) => {
            if (rs.data.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: rs.data.message,
                type: "error",
              });
            }
          });
        return;
      }
      if (
        confirm(
          `确定要${this.allAync ? "取消" : ""}同步所有机构下的所有设备吗？`
        )
      ) {
        this.allAync = !this.allAync;
        this.$http
          .post(`/senddataserver/${this.apiHost.path}/sync/all/`, {
            mchId: this.mchId,
            type: this.allAync ? 1 : 0,
          })
          .then((rs) => {
            if (rs.data.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: rs.data.message,
                type: "error",
              });
            }
          });
      } else {
        // this.allAync = false;
      }
      console.log("this.allAync", this.allAync);
      this.allAync2 = this.allAync;
    },
    getList() {
      //数据绑定
      let params = {
        page: this.pagin.pageNum,
        limit: this.pagin.size,
        insName: this.insName,
        mobile: this.mobile,
        mchId: +this.mchId,
        carNumber: this.carNumber || undefined,
        status: +this.status || undefined,
      };
      if (this.devId) {
        params.devId = +this.devId;
      }
      // this.radio = {};
      this.$http
        .post(`/senddataserver/${this.apiHost.path}/devMchPage`, params)
        .then((results) => {
          this.tableData = this.parseList(
            results["data"]["data"]["page"]["records"]
          );
          console.log(this.tableData);
          this.pagin.total = results["data"]["data"]["page"]["total"];
        });
    },

    onDelete(type, value = "") {
      console.log(type, value);
      let deleteIds = [];
      if (type === "list") {
        Object.keys(value).forEach((key) => {
          if (!key.includes("type:") && value[key]) {
            deleteIds.push(key + "");
          }
        });
      } else {
        if (value.includes("type:")) {
          this.tableData.forEach((item) => {
            if (item.activeId === value) {
              if (item.children) {
                item.children.forEach((item) => {
                  deleteIds.push(item.activeId + "");
                });
              }
            }
          });
        } else {
          deleteIds.push(value + "");
        }
      }
      if (deleteIds.length === 0) {
        alert("请先选择要删除的设备");
        return;
      }
      if (
        confirm(
          type !== "list" && value.includes("type:")
            ? "确认要删除该机构下的全部设备吗？"
            : "确认要删除吗？"
        )
      ) {
        console.log("delete", deleteIds, this.tableData);
        let ids = [];
        this.tableData.forEach((item) => {
          if (item.children) {
            item.children.forEach((_item) => {
              if (deleteIds.includes(_item.activeId + "")) {
                ids.push(_item.id);
              }
            });
          }
        });
        this.$http
          .put(`/senddataserver/${this.apiHost.path}/disassociate`, {
            mchId: this.mchId,
            idList: ids,
          })
          .then((rs) => {
            if (rs.data.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: rs.data.message,
                type: "error",
              });
            }
          });
      }
    },
    onLogout(type, value = "") {
      console.log(type, value);
      let deleteIds = [];
      if (type === "list") {
        Object.keys(value).forEach((key) => {
          if (!key.includes("type:") && value[key]) {
            deleteIds.push(key + "");
          }
        });
      } else {
        if (value.includes("type:")) {
          this.tableData.forEach((item) => {
            if (item.activeId === value) {
              if (item.children) {
                item.children.forEach((item) => {
                  deleteIds.push(item.activeId + "");
                });
              }
            }
          });
        } else {
          deleteIds.push(value + "");
        }
      }
      if (deleteIds.length === 0) {
        alert("请先选择要删除的设备");
        return;
      }
      if (
        confirm(
          type !== "list" && value.includes("type:")
            ? "确认要注销该机构下的全部设备吗？"
            : "确认要注销该设备吗？"
        )
      ) {
        console.log("delete", deleteIds, this.tableData);
        let ids = [];
        this.tableData.forEach((item) => {
          if (item.children) {
            item.children.forEach((_item) => {
              if (deleteIds.includes(_item.activeId + "")) {
                ids.push({
                  devId: _item.devId,
                  gdDevId: _item.gdDevId,
                  plateNo: _item.carNumber,
                });
              }
            });
          }
        });
        this.$http
          .post(
            `/senddataserver/${this.apiHost.path}/logout/all/`,

            ids
          )
          .then((rs) => {
            if (rs.data.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: rs.data.message,
                type: "error",
              });
            }
          });
      }
    },
    onRegister(type, value = "") {
      console.log(type, value);
      let deleteIds = [];
      if (type === "list") {
        Object.keys(value).forEach((key) => {
          if (!key.includes("type:") && value[key]) {
            deleteIds.push(key + "");
          }
        });
      } else {
        if (value.includes("type:")) {
          this.tableData.forEach((item) => {
            if (item.activeId === value) {
              if (item.children) {
                item.children.forEach((item) => {
                  deleteIds.push(item.activeId + "");
                });
              }
            }
          });
        } else {
          deleteIds.push(value + "");
        }
      }
      if (deleteIds.length === 0) {
        alert("请先选择要删除的设备");
        return;
      }
      if (
        confirm(
          type !== "list" && value.includes("type:")
            ? "确认要注销该机构下的全部设备吗？"
            : "确认要注册该设备吗？"
        )
      ) {
        let ids = [];
        this.tableData.forEach((item) => {
          if (item.children) {
            item.children.forEach((_item) => {
              if (deleteIds.includes(_item.activeId + "")) {
                ids.push({
                  devId: _item.devId,
                  gdDevId: _item.gdDevId,
                  plateNo: _item.carNumber,
                });
              }
            });
          }
        });
        console.log("ids", ids);
        this.$http
          .post(`/senddataserver/${this.apiHost.path}/register/single/`, {
            ...ids[0],
          })
          .then((rs) => {
            if (rs.data.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: rs.data.message,
                type: "error",
              });
            }
          });
      }
    },
    handleCheckChange(id, v) {
      const parent = this.tableData.filter((item) => item.activeId === id)[0];
      let copyRadio = { ...this.radio };
      if (parent) {
        // 没有children不处理父节点
        if (!parent.children) {
          return;
        }
        let ids = parent.children.map((item) => item.activeId);
        ids.forEach((id) => {
          copyRadio[id] = v;
        });
        console.log("copyRadio[", copyRadio);
        this.radio = copyRadio;
        return;
      }
      let _Parent = this.getParent(id, this.tableData);

      if (v) {
        let isAllSelect = true;
        _Parent.children.map((item) => {
          if (
            (!copyRadio[item.activeId] || copyRadio[item.activeId] === false) &&
            isAllSelect
          ) {
            isAllSelect = false;
          }
        });
        if (isAllSelect) {
          copyRadio[_Parent.activeId] = true;
        }
      } else {
        console.log(11);
        copyRadio[_Parent.activeId] = false;
      }
      this.radio = copyRadio;
    },
    getParent(id, list) {
      let parent = null;
      list.forEach((item) => {
        if (item.children) {
          item.children.forEach((_item) => {
            if (_item.activeId === id) {
              parent = item;
            }
          });
        }
      });
      return parent;
    },
    parseList(list) {
      const _list = [...list];
      _list.map((item, idx) => {
        item.activeId = `type:` + new Date().getTime() + idx;
        if (item.devList) {
          item.children = item.devList.map((_item) => {
            _item.activeId = _item.devId;
            return _item;
          });
          delete item.devList;
        }
      });
      return _list;
    },
    diffObj(newValue, oldValue) {
      const diff = {};

      for (let key in newValue) {
        if (newValue.hasOwnProperty(key)) {
          if (
            !oldValue.hasOwnProperty(key) ||
            oldValue[key] !== newValue[key]
          ) {
            diff[key] = newValue[key];
          }
        }
      }

      for (let key in oldValue) {
        if (oldValue.hasOwnProperty(key) && !newValue.hasOwnProperty(key)) {
          diff[key] = undefined;
        }
      }

      return Object.keys(diff).map((item) => [item, diff[item]])[0];
    },
    onData(data) {
      this.dataDialogVisible = true;
      this.formUpdate.devId = data.devId;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ConfirmLoading = true;
          this.$http
            .post(
              "/senddataserver/yunlizhi/handPush",
              this.formUpdate
            )
            .then((rs) => {
              if (rs.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.ConfirmLoading = false;
                this.dataDialogVisible = false;
                this.clean();
              } else {
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
                this.ConfirmLoading = false;
              }
            });
        } else {
          this.ConfirmLoading = false;
          return false;
        }
      });
    },
    clean() {
      this.$nextTick(() => {
        if (this.$refs.formUpdate) {
          this.$refs.formUpdate.resetFields();
        }
      });
    },
    closed() {
      this.clean();
    },
  },
  components: { Pagination },
};
</script>
